import type { UseFormProps } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useStore } from '@stores/RootStore';
import { EXTERNAL_MANAGER_EMAIL_REGEX } from '@utils/YupUtil';

// 전화번호 유효성 정규식 (최소 1자리 숫자 필수, 숫자와 공백만 허용)
export const PHONE_NUMBER_REGEX = /^[\d\s]*\d[\d\s]*$/;

export type FormContactUs = {
  name: string;
  email: string;
  phone: string;
  companyName: string;
  inquiry: string;
  softwareId: string;
};

export const useFormContactUs = () => {
  const { authStore } = useStore();
  const { t } = useTranslation();
  const validationFormSchema = Yup.object().shape({
    name: authStore.isLogin ? Yup.string() : Yup.string().required(t('Member_Group_Delete_05')),
    email: authStore.isLogin
      ? Yup.string().matches(EXTERNAL_MANAGER_EMAIL_REGEX, { message: t('Member_Manager_17'), excludeEmptyString: true })
      : Yup.string().required(t('Member_Group_Delete_05')).matches(EXTERNAL_MANAGER_EMAIL_REGEX, t('Member_Manager_17')),
    phone: authStore.isLogin
      ? Yup.string().trim().matches(PHONE_NUMBER_REGEX, { message: t('Validation.Numbers_Only'), excludeEmptyString: true })
      : Yup.string()
          .required(t('Validation.Required_Field'))
          .trim()
          .matches(PHONE_NUMBER_REGEX, { message: t('Validation.Numbers_Only') }),
    companyName: authStore.isLogin
      ? Yup.string().default('')
      : Yup.string().required(t('Validation.Required_Field')).default(''),
    inquiry: Yup.string().required(t('Validation.Required_Field')),
  });
  const formOptions: UseFormProps<FormContactUs> = {
    resolver: yupResolver(validationFormSchema),
    mode: 'onChange',
    shouldFocusError: true,
  };
  return useForm<FormContactUs>(formOptions);
};
